import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportCaptureStatusAndReasonOptionComponent } from '../../../shared/components/report-capture-status-and-reason-option/report-capture-status-and-reason-option.component';
import { ReportClientOptionComponent } from '../../../shared/components/report-client-option/report-client-option.component';
import { ReportSourcesOptionComponent } from '../../../shared/components/report-sources-option/report-sources-option.component';
import { ReportPharmacyPartnerOptionComponent } from '../../../shared/components/report-pharmacy-partner-option/report-pharmacy-partner-option.component';
import { ReportDateRangeOptionComponent } from '../../../shared/components/report-date-range-option/report-date-range-option.component';
import { ReportBooleanOptionComponent } from '../../../shared/components/report-boolean-option/report-boolean-option.component';
import { ReportTextOptionComponent } from '../../../shared/components/report-text-option/report-text-option.component';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportAppliedClientOptionComponent } from '../../../shared/components/report-applied-client-option/report-applied-client-option.component';
import { ReportAppliedCaptureStatusOptionComponent } from '../../../shared/components/report-applied-capture-status-option/report-applied-capture-status-option.component';
import { ReportAppliedCaptureStatusAndReasonOptionComponent } from '../../../shared/components/report-applied-capture-status-and-reason-option/report-applied-capture-status-and-reason-option.component';
import { ReportAppliedSourcesOptionComponent } from '../../../shared/components/report-applied-sources-option/report-applied-sources-option.component';
import { ReportAppliedPharmacyPartnerOptionComponent } from '../../../shared/components/report-applied-pharmacy-partner-option/report-applied-pharmacy-partner-option.component';
import { ReportAppliedBooleanOptionComponent } from '../../../shared/components/report-applied-boolean-option/report-applied-boolean-option.component';
import { ReportAppliedTextOptionComponent } from '../../../shared/components/report-applied-text-option/report-applied-text-option.component';
import { ReportAppliedDateRangeOptionComponent } from '../../../shared/components/report-applied-date-range-option/report-applied-date-range-option.component';

@Component({
  templateUrl: './capture-admin-capture-reports.component.html',
  imports: [
    ReportsComponent,
    NewReportOptionsTemplateDirective,
    FormsModule,
    ReactiveFormsModule,
    ReportCaptureStatusAndReasonOptionComponent,
    ReportClientOptionComponent,
    ReportSourcesOptionComponent,
    ReportPharmacyPartnerOptionComponent,
    ReportDateRangeOptionComponent,
    ReportBooleanOptionComponent,
    ReportTextOptionComponent,
    ReportDetailsTemplateDirective,
    ReportAppliedClientOptionComponent,
    ReportAppliedCaptureStatusOptionComponent,
    ReportAppliedCaptureStatusAndReasonOptionComponent,
    ReportAppliedSourcesOptionComponent,
    ReportAppliedPharmacyPartnerOptionComponent,
    ReportAppliedBooleanOptionComponent,
    ReportAppliedTextOptionComponent,
    ReportAppliedDateRangeOptionComponent
  ]
})
export class CaptureAdminCaptureReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/capture_reports`;
  reportsCountUrl = `${environment.captureApi.url}/capture_reports/count`;

  filtersForm = this.formBuilder.group({
    statusAndReasons: [null],
    clientIds: [null],
    highValueCandidatesOnly: [null],
    expiringWithinDays: [null],
    sources: [null],
    pharmacyPartnerNames: [null],
    verifiedDate: [null],
    createdDate: [null]
  });

  outputOptionsForm = this.formBuilder.group({
    includePhi: [null],
  });
}
